module.exports = __webpack_public_path__ + "static/media/profile.c916d6b0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/profile.JPG
// module id = 150
// module chunks = 0